'use client';

import clsx from 'clsx';
import { type FC, useState } from 'react';
import type { InlineGalleryComponent } from '@/types/inline-gallery';
import { InlineGalleryOverlay } from '@/components/raven/Blocks/InlineGalleryBlock/Overlay';
import { InlineGallerySlideComponent } from '@/components/raven/Blocks/InlineGalleryBlock/Slide';

import styles from '../styles.module.css';

export const InlineGalleryBlockComponent: FC<InlineGalleryComponent> = ({
	alignment,
	galleryId,
	slides,
}) => {
	const [slideIdx, setSlideIdx] = useState(0);

	return (
		<>
			<div
				className={clsx(styles.inlineGallery, {
					[styles.alignFull]: alignment === 'align-full',
				})}
			>
				{slides.map((slide, idx) =>
					slide.image ? (
						<InlineGallerySlideComponent
							key={`slide-${slide.image.id}`}
							{...slide}
							alignment={alignment}
							galleryId={galleryId}
							setSlideIdx={setSlideIdx}
							slideIdx={idx}
						/>
					) : null,
				)}
			</div>
			<InlineGalleryOverlay
				galleryId={galleryId}
				setSlideIdx={setSlideIdx}
				slideIdx={slideIdx}
				slides={slides}
			/>
		</>
	);
};
